import { CssBaseline } from "@mui/material";
import {
  createTheme,
  ThemeOptions,
  ThemeProvider as MUIThemeProvider,
} from "@mui/material/styles";
import { useMemo } from "react";
import breakpoints from "./breakpoints";
import GlobalStyles from "./globalStyles";
import palette from "./palette";
import typography from "./typography";
import shadows from "./shadows";

type Props = {
  readonly children: React.ReactNode;
};

const themeMode = "light";

export default function ThemeProvider({ children }: Props) {
  const themeOptions: ThemeOptions = useMemo(
    () => ({
      palette: palette(themeMode),
      typography,
      shape: { borderRadius: 8 },
      breakpoints,
      shadows: shadows(themeMode),
    }),
    []
  );

  const theme = createTheme(themeOptions);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      {children}
    </MUIThemeProvider>
  );
}
